import SpriteGenerator from "./SpriteGenerator";

const BlanketGenerator = props => {
  const blanket = SpriteGenerator(props);

  blanket.interactive = true;

  function onDragStart(event) {
    this.data = event.data;
    this.dragStartPosition = event.data.getLocalPosition(this.parent);
    this.dragging = true;
  }

  function onDragEnd() {
    this.dragging = false;
    this.data = null;
  }

  function onDragMove() {
    if (this.dragging) {
      var newPosition = this.data.getLocalPosition(this.parent);

      this.position.x = newPosition.x - blanket.width / 2;
    }
  }

  // setup events
  blanket
    // events for drag start
    .on("mousedown", onDragStart)
    .on("touchstart", onDragStart)
    // events for drag end
    .on("mouseup", onDragEnd)
    .on("mouseupoutside", onDragEnd)
    .on("touchend", onDragEnd)
    .on("touchendoutside", onDragEnd)
    // events for drag move
    .on("mousemove", onDragMove)
    .on("touchmove", onDragMove);

  return blanket;
};

export default BlanketGenerator;
